<template>
  <div class="nd-page">
    <header class="nd-page-header">
      <div>
        <h1 id="title" class="page-title">{{ pageTitle }}</h1>
        <p class="nd-page-kicker">Mantenha o nome do procedimento padronizado para consultas e prescrições.</p>
      </div>
    </header>

    <v-card class="nd-section-card">
      <v-form ref="procedureForm" v-model="formValid">
        <div class="nd-table-toolbar">
          <div>
            <div class="nd-table-toolbar__title">Dados do procedimento</div>
            <div class="nd-table-toolbar__subtitle">Informações principais do cadastro.</div>
          </div>
        </div>
        <div class="nd-form-grid">
          <v-text-field
            id="name"
            label="Nome"
            v-model="procedure.name"
            :rules="[rules.required]"
            outlined
            dense
           hide-details="auto"></v-text-field>
        </div>
        <div class="nd-form-actions">
          <v-btn id="btnCancel" type="button" color="primary" outlined elevation="0" @click="$router.push('/procedimentos')">
            Voltar
          </v-btn>
          <v-btn id="btnSave" type="button" color="primary" elevation="0" @click="saveProcedure" :loading="loadingSave">
            Salvar
          </v-btn>
        </div>
      </v-form>
    </v-card>

    <v-overlay :value="loadingPage">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ProceduresDetails",

  data: () => ({
    procedure: {
      id: null,
      name: "",
    },

    loadingPage: false,
    loadingSave: false,
    formValid: false,

    rules: {
      required: (value) => !!value || "Campo obrigatório.",
    },
  }),

  computed: {
    pageTitle() {
      return this.procedure.id ? "Detalhes do Procedimento" : "Novo Procedimento";
    },
    breadcrumbs() {
      const currentItemText = this.procedure.id ? "Detalhes do Procedimento" : "Novo Procedimento";
      return [
        { text: "Home", disabled: false, to: "/home", exact: true },
        { text: "Procedimentos", disabled: false, to: "/procedimentos", exact: true },
        { text: currentItemText, disabled: true, exact: true },
      ];
    },
  },

  async created() {
    this.loadingPage = true;
    const procedureId = this.$route.params.id;

    if (procedureId) {
      await this.loadProcedure(procedureId);
    }
    this.loadingPage = false;
  },

  methods: {
    async loadProcedure(id) {
      try {
        const response = await axios.get(`/procedures/${id}`);
        const data = response.data.data;
        this.procedure = {
          id: data.id,
          name: data.name,
        };
      } catch (error) {
        this.$dialog.notify.error("Erro ao carregar detalhes do procedimento.", {
          position: "top-right",
          timeout: 5000,
        });
      }
    },

    async saveProcedure() {
      if (this.$refs.procedureForm.validate()) {
        this.loadingSave = true;
        try {
          const payload = { name: this.procedure.name };

          if (this.procedure.id) {
            await axios.patch(`/procedures/${this.procedure.id}`, payload);
            this.$dialog.notify.success("Procedimento atualizado com sucesso!", {
              position: "top-right",
              timeout: 3000,
            });
          } else {
            await axios.post("/procedures", payload);
            this.$dialog.notify.success("Procedimento criado com sucesso!", {
              position: "top-right",
              timeout: 3000,
            });
          }
          this.$router.push("/procedimentos");
        } catch (error) {
          const code = error?.response?.data?.data?.code;
          const message = code === 1317
            ? "Já existe um procedimento com esse nome."
            : "Erro ao salvar procedimento. Verifique os dados.";
          this.$dialog.notify.error(message, {
            position: "top-right",
            timeout: 5000,
          });
        } finally {
          this.loadingSave = false;
        }
      }
    },
  },
};
</script>
